import { BaseContainerElement } from '../../BaseContainerElement';

class AccordionContainerItemElement extends BaseContainerElement {
}

export default AccordionContainerItemElement;